export default __webpack_public_path__ + "static/media/small_logo.82e03718.png";